/* Nightpass - pilote de la barre de livraison offerte.

   Remplace le script inline qui vivait dans le snippet. Deux differences qui
   comptent :
   - querySelectorAll : plusieurs barres peuvent coexister sur une meme page
     (haut du panier + rappel au-dessus du bouton de paiement).
   - le panier se met a jour sans rechargement ; on ecoute donc les evenements
     de Dawn en plus des clics d'ajout de la fiche produit. */

(function () {
  if (window.__npShipReady) return;
  window.__npShipReady = true;

  var rendering = false;
  var timer = null;

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  }

  function renderOne(box, total) {
    var threshold = parseInt(box.getAttribute('data-threshold'), 10) || 10000;
    var fill = box.querySelector('[data-np-ship-fill]');
    var msg = box.querySelector('[data-np-ship-msg]');
    if (!fill || !msg) return;

    fill.style.width = Math.max(0, Math.min(100, (total / threshold) * 100)) + '%';

    if (total >= threshold) {
      box.setAttribute('data-done', '');
      msg.innerHTML = 'Votre livraison est offerte';
    } else {
      box.removeAttribute('data-done');
      msg.innerHTML = 'Plus que <strong>' + money(threshold - total) + '</strong> pour la livraison offerte';
    }
  }

  function render(total) {
    rendering = true;
    var list = document.querySelectorAll('[data-np-ship]');
    for (var i = 0; i < list.length; i++) renderOne(list[i], total);
    setTimeout(function () { rendering = false; }, 0);
  }

  function refresh(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { render(c.total_price || 0); })
        .catch(function () {});
    }, delay || 0);
  }

  /* Fiche produit et chat : l'ajout part en fetch, on relit apres coup. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.product-form__submit, .np-chat-add, .np-bundle__btn')) refresh(900);
    if (e.target.closest('cart-remove-button, .quantity__button')) refresh(600);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('quantity__input')) refresh(600);
  });

  /* Filet de securite : Dawn reinjecte le total dans .js-contents apres chaque
     modification. On observe ce noeud, pas le bloc entier - la barre condensee
     vit en dehors, donc aucun risque de boucle avec nos propres ecritures. */
  function watch() {
    if (!window.MutationObserver) return;
    var targets = document.querySelectorAll('#main-cart-footer .js-contents, #main-cart-items .js-contents');
    for (var i = 0; i < targets.length; i++) {
      new MutationObserver(function () {
        if (rendering) return;
        refresh(120);
      }).observe(targets[i], { childList: true, subtree: true, characterData: true });
    }
  }

  function boot() {
    /* Enregistre seulement ici : pubsub.js est charge en defer dans le <head>,
       `subscribe` n'existe pas encore au moment ou ce fichier est evalue si on
       tente de s'y abonner trop tot. L'abonnement serait perdu en silence. */
    try {
      if (typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' &&
          PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(0); });
      }
    } catch (err) {}

    watch();
    refresh(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
